
/**
 * `CertificationCountBadge` — piccolo badge (coccarda + numero) che indica
 * quante certificazioni **valide** contribuiscono allo Score di una skill.
 *
 * Riprende lo stile del conteggio certificazioni della matrice "Livelli"
 * (`level-matrix__cert-count`): icona `award` con tono d'accento e numero a
 * fianco. Non viene reso quando il conteggio è `0`.
 *
 * È puramente presentazionale: il conteggio arriva da `AssessmentView.certificationCount`.
 */
import { Icon } from './ui';

export interface CertificationCountBadgeProps {
  /** Numero di certificazioni valide collegate alla skill. */
  count: number;
  /** Nome della skill, per l'etichetta accessibile. */
  skillName?: string;
}

export function CertificationCountBadge({
  count,
  skillName,
}: CertificationCountBadgeProps) {
  if (count <= 0) return null;
  const subject = skillName ? ` a ${skillName}` : '';
  const label =
    count === 1
      ? `1 certificazione valida collegata${subject} contribuisce allo Score`
      : `${count} certificazioni valide collegate${subject} contribuiscono allo Score`;
  return (
    <span
      className="score-cert-count"
      aria-label={label}
      title={label}
    >
      <Icon name="award" size={14} />
      {count}
    </span>
  );
}

export default CertificationCountBadge;
